export const LOCAL_STORE_KEY = "___hubs_store";

export function readLocalAuthSession(storage = localStorage) {
  const rawStore = storage?.getItem?.(LOCAL_STORE_KEY);

  if (!rawStore) {
    return null;
  }

  try {
    return JSON.parse(rawStore);
  } catch (_error) {
    return null;
  }
}

export function persistLocalAuthSession(storage = localStorage, { email = "", token = "" } = {}) {
  const store = readLocalAuthSession(storage) || {};
  const nextStore = {
    ...store,
    credentials: {
      ...(store.credentials || {}),
      email,
      token
    }
  };

  storage?.setItem?.(LOCAL_STORE_KEY, JSON.stringify(nextStore));

  return nextStore;
}

export function shouldEmitAuthenticationChanged(previousStore, { email = "" } = {}) {
  const previousEmail = previousStore?.credentials?.email || "";
  const wasAuthenticated = Boolean(previousStore?.credentials?.token);

  return !wasAuthenticated || previousEmail !== email;
}
